import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    name: 'Problema',
    id: 'problema'
  }, {
    name: 'Solución',
    id: 'solucion'
  }, {
    name: 'Resultados',
    id: 'resultados'
  }, {
    name: 'Proceso',
    id: 'proceso'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0A0A0A]/90 backdrop-blur-md border-b border-[#50C878]/20 py-3' : 'bg-transparent py-5'}`} data-id="element-192">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="flex items-center justify-between" data-id="element-194">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-195">
            <div className="w-8 h-8 bg-[#50C878] rounded-sm flex items-center justify-center text-black font-bold text-xs shadow-[0_0_10px_rgba(80,200,120,0.5)]" data-id="element-196">
              DE
            </div>
            <span className="text-white font-bold text-lg tracking-wider hidden sm:block" data-id="element-197">
              DOCTOR ECOMMERCE
            </span>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-198">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="text-[#C0C0C0] hover:text-[#50C878] transition-colors text-sm font-medium tracking-wide drop-shadow-md" data-id="element-199">
                {link.name}
              </button>)}
          </nav>

          {/* Desktop CTA & Phone */}
          <div className="hidden md:flex items-center gap-6" data-id="element-200">
            <a href="tel:4028720639" className="flex items-center gap-2 text-white hover:text-[#50C878] transition-colors font-semibold" data-id="element-201">
              <PhoneIcon className="w-4 h-4 text-[#50C878]" data-id="element-202" />
              402-872-0639
            </a>
            <button onClick={() => scrollToSection('contact-form')} className="bg-[#FFD700] hover:bg-[#e6c200] text-black font-bold px-5 py-2.5 rounded-lg transition-all neon-glow" data-id="element-203">
              Diagnóstico GRATIS
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-white p-2 hover:text-[#50C878] transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-204">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-205" /> : <MenuIcon className="w-6 h-6" data-id="element-206" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <AnimatePresence data-id="element-207">
        {isMobileMenuOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="md:hidden bg-[#0A0A0A] border-b border-[#50C878]/20 overflow-hidden" data-id="element-208">
            <div className="px-4 py-6 flex flex-col gap-4" data-id="element-209">
              {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="text-left text-[#C0C0C0] hover:text-[#50C878] py-2 text-lg font-medium transition-colors" data-id="element-210">
                  {link.name}
                </button>)}
              <div className="h-px w-full bg-white/10 my-2" data-id="element-211"></div>
              <a href="tel:4028720639" className="flex items-center gap-2 text-white py-2 font-semibold text-lg hover:text-[#50C878] transition-colors" data-id="element-212">
                <PhoneIcon className="w-5 h-5 text-[#50C878]" data-id="element-213" />
                402-872-0639
              </a>
              <button onClick={() => scrollToSection('contact-form')} className="bg-[#FFD700] text-black font-bold px-5 py-3 rounded-lg mt-2 text-center neon-glow" data-id="element-214">
                Diagnóstico GRATIS
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}